import { AiReviewStatus } from '@treadinc/horizon-api-spec';

import { AiReview } from '~hooks/useAiReview/models';
import { AnalyticsController } from '~hooks/useAnalytics/AnalyticsController';
import { secondsOnPage } from '~hooks/useAnalytics/useSecondsOnPageTracker';
import { Nullable } from '~types/Nullable';

interface ApprovedLoad {
  aiReview?: Nullable<AiReview>;
  id: string;
}

export function trackAiReviewRejected(loadId: string) {
  AnalyticsController.track('ai_suggestion_resolved', {
    feature: 'ticket_review',
    object_id: loadId,
    outcome: 'rejected',
  });
}

export function trackLoadsApproved(loads: ApprovedLoad[]) {
  const activelyReviewedLoads = loads.filter(
    ({ aiReview }) => aiReview && !aiReview.dismissedAt,
  );
  const aiPassedLoads = activelyReviewedLoads.filter(
    ({ aiReview }) => aiReview?.status === AiReviewStatus.APPROVED,
  );

  AnalyticsController.track('approval_batch_submitted', {
    ai_passed_count: aiPassedLoads.length,
    count: loads.length,
    object_type: 'load',
    seconds_on_page: secondsOnPage(),
  });

  activelyReviewedLoads.forEach((load) => {
    if (aiPassedLoads.includes(load)) {
      AnalyticsController.track('ai_suggestion_resolved', {
        feature: 'ticket_review',
        object_id: load.id,
        outcome: 'accepted',
      });
    } else {
      trackAiReviewRejected(load.id);
    }
  });
}

export function trackApprovalBatch(objectType: 'job' | 'driver_day', count: number) {
  AnalyticsController.track('approval_batch_submitted', {
    ai_passed_count: 0,
    count,
    object_type: objectType,
    seconds_on_page: secondsOnPage(),
  });
}

export async function approveAllWithTracking<Item>(
  items: Item[],
  approve: (item: Item) => Promise<unknown>,
  trackApproved: (approvedItems: Item[]) => void,
) {
  const results = await Promise.allSettled(items.map(approve));
  const approvedItems = items.filter((_, index) => results[index].status === 'fulfilled');

  if (approvedItems.length > 0) {
    trackApproved(approvedItems);
  }

  const firstFailure = results.find((result) => result.status === 'rejected');

  if (firstFailure) {
    throw firstFailure.reason;
  }
}
